module.exports = __webpack_public_path__ + "static/media/support.04732b5f.svg";